var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.89 63.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9d9d9;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #737373;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.06,42.32l7.53-7.47c6.14-6.08,6.14-15.97,0-22.06-6.14-6.08-16.1-6.08-22.23,0L4.6,37.34c-6.14,6.09-6.14,15.97,0,22.06s16.1,6.09,22.24,0c1.75-1.74,1.75-4.56,0-6.3-1.76-1.74-4.6-1.74-6.35,0-2.63,2.61-6.9,2.61-9.53,0s-2.63-6.84,0-9.45l24.75-24.55c2.63-2.61,6.9-2.61,9.54,0,2.63,2.61,2.63,6.84,0,9.45l-7.54,7.47c-1.76,1.74-1.76,4.56,0,6.3s4.6,1.74,6.35,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.11,23.36l-5.81,5.76c-6.14,6.09-6.14,15.97,0,22.06,6.14,6.09,16.1,6.09,22.24,0l24.75-24.55c6.14-6.08,6.14-15.97,0-22.06-6.14-6.08-16.1-6.08-22.23,0-1.76,1.74-1.76,4.56,0,6.3,1.75,1.74,4.6,1.74,6.35,0,2.63-2.61,6.9-2.61,9.53,0s2.63,6.84,0,9.45l-24.76,24.55c-2.63,2.61-6.9,2.61-9.53,0s-2.63-6.84,0-9.45l5.81-5.76c1.75-1.74,1.75-4.56,0-6.3-1.76-1.74-4.6-1.74-6.35,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlGrey);
export default __webpack_public_path__ + "static/media/url-grey.6c0956efa654af709e28d80610d7f609.svg";
export { ForwardRef as ReactComponent };